import React, { useContext, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { filterContext } from "../ConciliacionPage";
import * as conciliacion from "../../../services/conciliacion.service";
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "as400", label: "AS400", minWidth: 1 },
  { id: "articulo", label: "Árticulo", minWidth: 1 },
  { id: "descripcion", label: "Descripción", minWidth: 1 },
  { id: "unidad_total", label: "UNID", minWidth: 1, align: "center"},
  { id: "pzstotal", label: "PZS", minWidth: 11, align: "center"},
  { id: "unidad_estandar", label: "UNID", minWidth: 1, align: "center" },
  { id: "pzsestandar", label: "PZS", minWidth: 1, align: "center" },
  { id: "unida_pila", label: "UNID", minWidth: 1, align: "center" },
  { id: "pzspila", label: "PZS", minWidth: 1, align: "center" },
  { id: "unidad_tarima", label: "UNID", minWidth: 1, align: "center" },
  { id: "pzstarima", label: "PZS", minWidth: 1, align: "center" },
  { id: "unidad_restos", label: "UNID", minWidth: 1, align: "center" },
  { id: "pzsrestos", label: "PZS", minWidth: 1, align: "center" },
];

const columnsD = [
  { id: "lpn", label: "LPN", minWidth: 1},
  { id: "as400", label: "AS400", minWidth: 1 },
  { id: "item", label: "ORACLE", minWidth: 1 },
  { id: "descripcion", label: "DESCRIPCIÓN", minWidth: 1 },
  { id: "cantidad", label: "CANTIDAD", minWidth: 1, align: "center"},
  { id: "uom", label: "UDM", minWidth: 11, align: "center"},
  { id: "envio", label: "# ENVIO", minWidth: 1, align: "center" },
  { id: "fecha", label: "FECHA", minWidth: 1, align: "center" }
];

const Devoluciones = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageD, setPageD] = useState(0);
  const [rowsPerPageD, setRowsPerPageD] = useState(10);
  const navigate = useNavigate();
  const [itemId, setItemId] = useState()

  const { filtros } = useContext(filterContext);
  const [master, setMaster] = useState([]);
  const [totales, setTotales] = useState([])
  
  const [detail, setDetail] = useState([]);
  const [detailFiltered, setDetailFiltered] = useState([]);
  const [isFetching, setIsFetching] = useState(false)

  const calculateTotal = (array, field) => array.reduce((accumulator, currentValue) => accumulator + currentValue[field] , 0);

  useEffect(() => {
    if(!filtros) {navigate(`/v1/conciliacion`)} else {
      setMaster([])
      setIsFetching(true)
      conciliacion.getDevoluciones(filtros.area, filtros.fecha, filtros.turno)
      .then(resp => {
        setMaster(resp.masters)
        setDetail(resp.details)
        setTotales([
          calculateTotal(resp.masters, 'unidad_total'),
          calculateTotal(resp.masters, 'pzstotal'),
          calculateTotal(resp.masters, 'unidad_estandar'),
          calculateTotal(resp.masters, 'pzsestandar'),
          calculateTotal(resp.masters, 'unida_pila'),
          calculateTotal(resp.masters, 'pzspila'),
          calculateTotal(resp.masters, 'unidad_tarima'),
          calculateTotal(resp.masters, 'pzstarima'),
          calculateTotal(resp.masters, 'unidad_restos'),
          calculateTotal(resp.masters, 'pzsrestos')
        ])
      })
      .finally(() => setIsFetching(false))
    }
  }, [filtros])
  
  const handleSelectResult = (pro) => {
    setItemId(pro.item_id)
    setDetailFiltered(detail.filter(d => d.item === pro.articulo))
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePageD = (event, newPage) => {
    setPageD(newPage);
  };

  const handleChangeRowsPerPageD = (event) => {
    setRowsPerPageD(+event.target.value);
    setPageD(0);
  };
  
  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '1rem' }}>
        <TableContainer sx={{ maxHeight: '70vh' }}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow >
                <TableCell align="center" colSpan={3} sx={{fontSize: '12px', backgroundColor: '#f1f1f1'}}>
                  ÁRTICULO
                </TableCell>
                <TableCell align="center" colSpan={2} sx={{fontSize: '12px'}}>
                  TOTAL
                </TableCell>
                <TableCell align="center" colSpan={2} sx={{fontSize: '12px', backgroundColor: '#f1f1f1'}}>
                  ESTANDAR
                </TableCell>
                <TableCell align="center" colSpan={2} sx={{fontSize: '12px'}}>
                  PILA
                </TableCell>
                <TableCell align="center" colSpan={2} sx={{fontSize: '12px', backgroundColor: '#f1f1f1'}}>
                  TARIMA
                </TableCell>
                <TableCell align="center" colSpan={2} sx={{fontSize: '12px'}}>
                  RESTOS
                </TableCell>
              </TableRow>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontSize: '12px' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell 
                    style={{ color: '#1976d2'}}
                  >
                    TOTALES
                  </TableCell>

                  {totales.map((t, idx) => (
                    <TableCell key={idx} align={'center'} style={{ color: '#1976d2' }}>{t}</TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {master.length > 0 ? master
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow 
                          hover 
                          role="checkbox"
                          selected={row.item_id === itemId}
                          tabIndex={-1} 
                          key={row.pickingId}
                          sx={{cursor: 'pointer'}}
                          onClick={() => handleSelectResult(row)}
                      >
                      {columns.map((column) => {
                        const value = row[column.id];

                        return (
                          <TableCell key={column.id} align={column.align} sx={{fontSize: '11px'}}>
                            {column.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                }): undefined}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={master.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      
      {master.length > 0 ? (<><Typography variant="h5" sx={{marginTop: '1rem'}}>Detalle</Typography>
      <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '1rem' }}>
        <TableContainer sx={{ maxHeight: '70vh' }}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columnsD.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontSize: '12px' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {detailFiltered.length > 0 ? detailFiltered
                .slice(pageD * rowsPerPageD, pageD * rowsPerPageD + rowsPerPageD)
                .map((row) => {
                  return (
                    <TableRow 
                          hover 
                          role="checkbox"
                          selected={row.item_id === itemId}
                          tabIndex={-1} 
                          key={row.pickingId}
                          sx={{cursor: 'pointer'}}
                      >
                      {columnsD.map((column) => {
                        const value = row[column.id];

                        return (
                          <TableCell key={column.id} align={column.align} sx={{fontSize: '11px'}}>
                            {column.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                }): undefined}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={detailFiltered.length}
          rowsPerPage={rowsPerPageD}
          page={pageD}
          onPageChange={handleChangePageD}
          onRowsPerPageChange={handleChangeRowsPerPageD}
        />
      </Paper></>) : undefined}
      <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={isFetching}
      >
        <CircularProgress color="inherit" sx={{ marginRight: 2 }} />
        <Typography variant="h4" gutterBottom>
          Cargando Devoluciones
        </Typography>
      </Backdrop>
    </>
  );
};

export default Devoluciones;
